import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Gamepad2, Wand2, Sparkles, Trophy, Link2, Maximize2 } from 'lucide-react';
import { fetchSettings } from '../api';

const SacredAiko = () => {
  const [settings, setSettings] = useState({ sacredAikoUrl: '', sacredAikoTitle: 'Sacred Aiko', sacredAikoTagline: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings().then((s) => setSettings((prev) => ({ ...prev, ...s }))).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const hasGame = !!settings.sacredAikoUrl;

  return (
    <div className="pt-28 pb-24 min-h-screen">
      <section className="relative py-12 overflow-hidden">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 h-[420px] w-[420px] rounded-full bg-[#d6197d]/15 blur-[120px] glow-pulse" />
        <div className="relative max-w-3xl mx-auto px-5 text-center">
          <Gamepad2 className="h-14 w-14 text-[#ff4da6] mx-auto mb-5 floaty" />
          <p className="font-jost text-xs tracking-[0.4em] text-[#ff4da6] uppercase mb-3">A Sister Experience</p>
          <h1 className="font-cinzel text-4xl md:text-6xl text-gold-gradient">{settings.sacredAikoTitle || 'Sacred Aiko'}</h1>
          <div className="gold-divider my-6" />
          <p className="font-cormorant text-xl md:text-2xl text-[#f5ecd9]/75">{settings.sacredAikoTagline || 'A space within the Prestige Elements universe where energy, elements and interactive discovery meet.'}</p>
          <div className="mt-8">
            {hasGame ? (
              <a href={settings.sacredAikoUrl} target="_blank" rel="noreferrer" data-testid="enter-sacred-aiko" className="inline-flex items-center gap-2 btn-gold rounded-full px-8 py-3.5 text-sm font-semibold text-[#0a0708] bg-gradient-to-r from-[#d4af37] to-[#f0d582] hover:shadow-lg transition-all"><Gamepad2 className="h-5 w-5" /> Enter Sacred Aiko</a>
            ) : (
              <span data-testid="sacred-aiko-coming" className="inline-flex items-center gap-2 rounded-full px-8 py-3.5 text-sm font-jost uppercase tracking-widest text-[#f5ecd9]/50 border border-white/15">Play link coming soon</span>
            )}
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-5 py-8">
        <div className="card-glass rounded-3xl p-4 md:p-6">
          <div className="relative aspect-video rounded-2xl overflow-hidden bg-[#0d0a0c] border border-[#d4af37]/20 flex items-center justify-center">
            {hasGame ? (
              <iframe title="Sacred Aiko" src={settings.sacredAikoUrl} className="w-full h-full" allow="fullscreen; autoplay; gamepad" />
            ) : (
              <div className="text-center px-6">
                <div className="h-20 w-20 mx-auto rounded-full border border-[#d4af37]/30 flex items-center justify-center mb-5 spin-slow"><Wand2 className="h-8 w-8 text-[#f0d582]" /></div>
                <p className="font-cinzel text-2xl text-gold-gradient">{loading ? 'Loading…' : 'The Experience Awaits'}</p>
                <p className="font-jost text-sm text-[#f5ecd9]/50 mt-2 max-w-md mx-auto">Your Sacred Aiko game will appear here once its link is connected. It can be updated anytime from the admin dashboard — no code changes needed.</p>
              </div>
            )}
          </div>
          {hasGame && (
            <div className="flex justify-end mt-3">
              <a href={settings.sacredAikoUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-xs text-[#f0d582] hover:text-[#ff4da6] font-jost uppercase tracking-widest"><Maximize2 className="h-3.5 w-3.5" /> Open Full Screen</a>
            </div>
          )}
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-5 py-12">
        <div className="grid md:grid-cols-3 gap-7">
          {[
            { icon: Trophy, t: 'Earn Rewards', d: 'Play to unlock exclusive perks on the Prestige shop. (Coming soon.)' },
            { icon: Link2, t: 'Two-Way Sync', d: 'Connect your game to your Prestige account and back. (Coming soon.)' },
            { icon: Sparkles, t: 'Elemental Play', d: 'A holistic experience woven from the same energy as our products.' },
          ].map((p) => (
            <div key={p.t} className="card-glass rounded-2xl p-8 text-center hover-lift"><div className="h-14 w-14 mx-auto rounded-full border border-[#d4af37]/30 flex items-center justify-center mb-4"><p.icon className="h-6 w-6 text-[#f0d582]" /></div><h3 className="font-cinzel text-lg text-[#f5ecd9] mb-2">{p.t}</h3><p className="font-jost text-sm text-[#f5ecd9]/60">{p.d}</p></div>
          ))}
        </div>
        <div className="text-center mt-10"><Link to="/" className="font-jost text-sm tracking-widest uppercase text-[#f0d582] border-b border-[#d4af37]/50 pb-1 hover:text-[#ff4da6] transition-colors">Back to Prestige Elements</Link></div>
      </section>
    </div>
  );
};

export default SacredAiko;
